"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./drawer.css");
exports.default = {
    drawer: 'pf-c-drawer',
    drawerContent: 'pf-c-drawer__content',
    drawerPanel: 'pf-c-drawer__panel',
    drawerContentBody: 'pf-c-drawer__content-body',
    drawerPanelBody: 'pf-c-drawer__panel-body',
    modifiers: {
        'padding': 'pf-m-padding',
        'noPadding': 'pf-m-no-padding',
        'expanded': 'pf-m-expanded',
        'divider': 'pf-m-divider',
        'panelLeft': 'pf-m-panel-left',
        'inline': 'pf-m-inline',
        'width_25': 'pf-m-width-25',
        'width_33': 'pf-m-width-33',
        'width_50': 'pf-m-width-50',
        'width_66': 'pf-m-width-66',
        'width_75': 'pf-m-width-75',
        'width_25OnLg': 'pf-m-width-25-on-lg',
        'width_33OnLg': 'pf-m-width-33-on-lg',
        'width_50OnLg': 'pf-m-width-50-on-lg',
        'width_66OnLg': 'pf-m-width-66-on-lg',
        'width_75OnLg': 'pf-m-width-75-on-lg',
        'width_25OnXl': 'pf-m-width-25-on-xl',
        'width_33OnXl': 'pf-m-width-33-on-xl',
        'width_50OnXl': 'pf-m-width-50-on-xl',
        'width_66OnXl': 'pf-m-width-66-on-xl',
        'width_75OnXl': 'pf-m-width-75-on-xl',
        'width_25On_2xl': 'pf-m-width-25-on-2xl',
        'width_33On_2xl': 'pf-m-width-33-on-2xl',
        'width_50On_2xl': 'pf-m-width-50-on-2xl',
        'width_66On_2xl': 'pf-m-width-66-on-2xl',
        'width_75On_2xl': 'pf-m-width-75-on-2xl'
    }
};
